import { RootState } from 'store/rootReducer';
import { selectorsFactory } from 'store/entities/utils';
import * as keyWindowNames from './keyWindowNames';

export const adminSessionsTranslationsSlice = (state: RootState) => state.entities.adminEventSessionsTranslations;

export const adminSessionsTranslationsState = selectorsFactory.createDynamicKeyWindowStateMemoizedSelector(
  adminSessionsTranslationsSlice,
  keyWindowNames.adminEventSessionsTranslations,
);
